import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TabSimple } from '@modules/tab/interfaces/tab.interface';

@Component({
  selector: 'app-tab-simple',
  templateUrl: './tab-simple.component.html',
  styleUrls: ['./tab-simple.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TabSimpleComponent {
  @Input() labels: any[] = [
  ];
  @Input() selectedIndex: string = '0';
  @Input() width: string = '335px';
  @Output() currentTab: EventEmitter<TabSimple> = new EventEmitter();

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    const position = tabChangeEvent.index;
    this.currentTab.emit({ position });
  }
}
